import { useGetPlanRewardsQuery } from "@apis/offers/useOffers"
import { OfferPromoAndLoyaltyProgramSection } from "@components/MemberNew/Utils"
import { Loader2 } from "lucide-react"

export const CustomOfferPlanRewards = ({
  plan_code,
}: {
  plan_code: string
}) => {
  const getPlanRewards = useGetPlanRewardsQuery(plan_code)

  return (
    <>
      {getPlanRewards.isPending ? (
        <Loader2 className="tw:h-6 tw:w-6 tw:animate-spin tw:text-gray-500" />
      ) : getPlanRewards.isError ? (
        <div className="tw:text-destructive">
          There was an error loading rewards for plan. Error:{" "}
          {getPlanRewards.error.message}
        </div>
      ) : (
        <div>
          <OfferPromoAndLoyaltyProgramSection
            title="Promos:"
            items={getPlanRewards.data?.promos}
            getLabel={(promo) => promo.promo_desc}
          />
          <OfferPromoAndLoyaltyProgramSection
            title="Loyalty Programs:"
            items={getPlanRewards.data?.loyalty_programs}
            getLabel={(lp) => lp.loyalty_program_desc}
          />
        </div>
      )}
    </>
  )
}
